import { AnimatePresence, motion } from "motion/react";
import React from "react";
import type { RenderCursorProps } from "./types";
import { cn } from "@/lib/utils";

function RenderCursor({
  render,
  position,
  cursorType,
  cursorComponent,
  hoverTarget,
  resetCursor,
}: RenderCursorProps) {
  const cursorRef = React.useRef<HTMLDivElement | null>(null);

  const isCustom = cursorType === "custom" || cursorType === "follow";
  const isHidden = cursorType === "hidden";

  if (!render) {
    return null;
  }

  return (
    <AnimatePresence>
      {!isHidden && !isCustom && (
        <motion.div
          ref={cursorRef}
          className={cn(
            "fixed top-0 left-0 z-[9999] pointer-events-none bg-white w-4 h-4 rounded-full mix-blend-difference",
          )}
          style={{
            top: position.y - 16,
            left: position.x - 16,
          }}
          animate={{
            scale: cursorType === "grow" ? 2 : 1,
            opacity: cursorType === "hidden" ? 0 : 1,
          }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 25,
          }}
        />
      )}

      {!isHidden && isCustom && (
        <motion.div
          ref={cursorRef}
          className={cn("fixed top-0 left-0 z-[9999]")}
          style={{
            top: position.y - 16,
            left: position.x - 16,
          }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 25,
          }}
        >
          {cursorComponent}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default React.memo(RenderCursor);
